import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import ChartContainer from "../../../../../../app/common-components/ChartContainer";
import Spinners from "../../../../../../app/common-components/Spinner";
import CatagorizedContainer from "./catagoryContanier";
import "./styles.css";
import Uncategorised from "./uncatagorizedContanier";
import { CATEGORY_TYPES } from "./Utilities/Identifiers";

const JiraPriority = (props) => {
  const { PriorityCatagorizedData, PriorityConfigJiraListLoading } =
    useSelector((state) => state.toolsApi);

  const activeTab = props.activeTab;

  const PriorityData = Array.isArray(PriorityCatagorizedData)
    ? PriorityCatagorizedData
    : [];

  const categorizedData = PriorityData.filter(
    (item) => item.categoryName !== CATEGORY_TYPES.UNCATEGORIZED
  ).sort((a, b) => a.priorityOrder - b.priorityOrder);

  const uncategorizedData = PriorityData.find(
    (item) => item?.categoryName === CATEGORY_TYPES.UNCATEGORIZED
  );

  const PriorityUnCategorized = uncategorizedData?.priorityType?.length
    ? [
        {
          key: "uncategorized",
          data: uncategorizedData?.priorityType,
          itemCount: uncategorizedData?.priorityType?.length,
          chart: (props) => (
            <Uncategorised
              list={uncategorizedData?.priorityType}
              count={uncategorizedData?.priorityType?.length}
              {...props}
            />
          ),
          navContainerClass: "flowdisnav",
          chartContainerClass: "flowdistribution svg-container",
          customClass:
            "col-lg-12 col-md-12 order-md-6 order-lg-5 filtercol filetotal jiraUncatagorized",
        },
      ]
    : [];

  const PriorityCategorized = categorizedData.map((category) => ({
    key: category.configId ?? category.categoryName,
    chart: (props) => (
      <CatagorizedContainer
        title={category?.categoryName}
        order={category?.priorityOrder}
        data={
          Array.isArray(category?.priorityType) ? category?.priorityType : []
        }
        itemCount={
          Array.isArray(category?.priorityType)
            ? category?.priorityType?.length
            : 0
        }
        activeTab={activeTab}
        {...props}
      />
    ),
    navContainerClass: "flowdisnav",
    chartContainerClass: "flowdistribution svg-container",
    customClass:
      "col-lg-12 col-md-12 order-md-6 order-lg-5 filtercol filetotal jiraCategorized",
  }));

  return (
    <>
      {PriorityConfigJiraListLoading ? (
        <Spinners />
      ) : (
        <>
          {PriorityUnCategorized.map((type) => {
            return (
              <ChartContainer
                key={type.key}
                {...type}
                // list={uncatData}
                // count={7}
              >
                {type.component}
              </ChartContainer>
            );
          })}
          {PriorityCategorized.map((type) => {
            return (
              <ChartContainer key={type.key} {...type}>
                {type.component}
              </ChartContainer>
            );
          })}
        </>
      )}
    </>
  );
};
JiraPriority.propTypes = {
  activeTab: PropTypes.string.isRequired,
};

export default JiraPriority;
